import { createApp } from 'vue';
import axios from 'axios';
import courseItem from "../vueComponents/courseItem.vue";
import courseSortButton from "../vueComponents/courseSortButton.vue";

export default {
    name : 'courses-table',

    _selector : '#courses-app',

    init() {
        if (document.querySelector(this._selector)) {
            this.run();
        }
    },

    run()
    {
        const app = createApp({
            delimiters: ['@{', '}'],

            data() {
                return {
                    currentCourseId: null,
                    items : [],
                    results : [],
                    orderBy : 'title',
                    order : 'asc',
                    keyword : ""
                }
            },

            computed: {
                sortedItems() {
                    // console.log(`${this.orderBy} ${this.order} `);


                    let items = this.items;
                    // title
                    if (this.orderBy === 'title' ) {
                        items = this.stringSort(items, this.orderBy);
                    }
                    // courseLocation
                    else if (this.orderBy === 'courseLocation') {
                        items = this.stringSort(items, this.orderBy);
                    }
                    // startDate
                    else if (this.orderBy === 'startDate') {
                        items = this.dateSort(items, this.orderBy);
                    }
                    // duration
                    else if (this.orderBy === 'duration') {
                        items = this.numberSort(items, this.orderBy)
                    }
                    // price
                    else if (this.orderBy === 'coursePrice') {
                        items = this.numberSort(items, this.orderBy)
                    }
                    // courseCapacity
                    else if (this.orderBy === 'courseCapacity') {
                        items = this.numberSort(items, this.orderBy)
                    }

                    return items;
                }
            },

            methods:
            {
                stringSort(items, attr) {
                    if (this.order === 'asc') {
                        items = items.sort((a, b) => a[attr].localeCompare(b[attr]));
                    } else {
                        items = items.sort((a, b) => b[attr].localeCompare(a[attr]));
                    }

                    return items;
                },

                dateSort(items, attr) {
                    if (this.order === 'asc') {
                        items = items.sort((a, b) => new Date(a[attr]) - new Date(b[attr]));
                    } else  {
                        items = items.sort((a, b) => new Date(b[attr]) - new Date(a[attr]));
                    }

                    return items;
                },

                numberSort(items, attr) {
                    if (this.order === 'asc') {
                        items = items.sort((a, b) => parseInt(a[attr]) - parseInt(b[attr]));
                    } else  {
                        items = items.sort((a, b) => parseInt(b[attr]) - parseInt(a[attr]));
                    }

                    return items;
                },

                setOrderBy(string) {
                    if (this.orderBy === string) {
                        // Toggle order if clicking on the same column
                        this.order = this.order === 'asc' ? 'desc' : 'asc';
                    } else {
                        // Set new orderBy and default to ascending order
                        this.orderBy = string;
                        this.order = 'asc';
                    }
                },

                getCourses()
                {
                    const metaElement = document.querySelector('meta[name="currentSiteUrl"]');
                    const url = metaElement.content+"actions/tibe/courses/index?course="+this.currentCourseId;

                    axios.get(url)
                        .then(this.getCourses__callback)
                        .catch(function (error) {
                            // handle error
                            console.log(error);
                        });
                },

                getCourses__callback(response) {
                    const items = response.data.data ?? [];
                    // console.log(items)

                    if (typeof  items === 'object' && items.length > 0) {
                        this.items = items;
                    }
                },
            },
            created ()
            {
                const container = document.querySelector('#courses-app');


                if (container && typeof container.dataset.course !== 'undefined' ) {
                    this.currentCourseId = container.dataset.course;
                }

                this.getCourses();
            }
        });

        app.component('course-item', courseItem);
        app.component('course-sort-button', courseSortButton);
        app.mount(this._selector);
    }
}
